var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isTemplate && _vm.id === 'createTemplate')?_c('div',{staticClass:"template-id"},[_c('string',{attrs:{"placeholder":"Template ID","label":"Template ID","value":_vm.value,"rules":_vm.clientIdRegex,"tooltip":"Alphanumeric characters only."},on:{"setConfigValue":_vm.setConfigValue}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }